
export default function Integrations() {
  const integrations = [
    {
      name: 'QuickBooks Online',
      logo: 'ri-bar-chart-box-line',
      description: 'Direct posting to your QuickBooks Online account',
      status: 'Available'
    },
    {
      name: 'QuickBooks Desktop',
      logo: 'ri-computer-line',
      description: 'Seamless integration with QuickBooks Desktop',
      status: 'Available'
    },
    {
      name: 'MSBC',
      logo: 'ri-building-line',
      description: 'Complete MSBC integration for enterprise needs',
      status: 'Available'
    },
    {
      name: 'Xero',
      logo: 'ri-line-chart-line',
      description: 'Coming soon for Xero users',
      status: 'Coming Soon'
    },
    {
      name: 'Sage',
      logo: 'ri-pie-chart-line',
      description: 'Sage integration in development',
      status: 'Coming Soon'
    },
    {
      name: 'Gmail',
      logo: 'ri-mail-line',
      description: 'Automatic invoice capture from Gmail',
      status: 'Available'
    }
  ];

  return (
    <section id="integrations" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Integrates with Your Existing Tools
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Works seamlessly with the accounting software you already use. No switching required.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {integrations.map((integration, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className={`${integration.logo} text-xl text-blue-600`}></i>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  integration.status === 'Available' 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {integration.status}
                </span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{integration.name}</h3>
              <p className="text-gray-600 text-sm">{integration.description}</p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">Don't see your accounting software? We're adding new integrations every month.</p>
          <button className="text-blue-600 hover:text-blue-700 font-medium cursor-pointer">
            Request an Integration <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
